import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton, AppBar, Toolbar } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { Tab, Tabs } from 'material-ui';
import Loader from "other-components/loader/loader";
import CloseIcon from '@material-ui/icons/Close';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import $ from "jquery";
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { withAlert } from 'react-alert';
import Tooltip from 'material-ui/Tooltip';


const styles = theme => ({
    layoutRoot: {}
});

var editNic = null;
var editImgUrl = null;
var editEmpId = null;
var editEmpCode = null;
var editRefNo = null;
var editEPF = null;
var editFirstName = null;
var editLastName = null;
var editMiddleName = null;
var editEmpRegId = null;
var editSalaryId = null;
var editAppoimentData = null;
var editProbationPeriod = null;
var editDepartment = null;
var editDesignation = null;
var editGreade = null;
var editEmployeement = null;
var editPermentShift = null;
var editBasicSalary = null;
var editPaymentMethod = null;
var editTimeCategory = null;
var editEmployeeStatus = null;

var hh = null;
var colorName = null;
var editGender = null;
var editGreade = null;
var updateTradeName = null;
var isActive = null;

var deleteEmpId = null;
var deleteFirstName = null;
var deleteLastName = null;

class Tab1LoadEmployeePersonalDetails extends Component {

    state = {
        canSubmit: false,
        // value :0
    };

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            data: [],
            loadDepartmentTypes: [],
            loadDesignationTypes: [],
            loadEmployementTypes: [],
            loadPaymentTypes: [],
            loadTimeCategoryTypes: [],
            loading: true,

            genderMaleChecked: false,
            genderFemaleChecked: false,
            genderOtherChecked: false,
        };
        this.loadData();
        this.loadDepartmentTypes();
        this.loadDesignationTypes();
        this.loadEmployementTypes();
        this.loadPaymentTypes();
        this.loadTimeCategoryTypes();

        this.state = {
            imageURL: 'assets/images/default-avatar.png',
        };

        this.handleUploadImageEdit = this.handleUploadImageEdit.bind(this);
    }

    // get all emplooyee salary details where profile id
    loadEmployeeSalaryDetailsById(editEmpId) {

        var empIdObj = {
            editEmpId: editEmpId
        }

        axios.post(window.hrmServer + '/getEmployeeSalaryDatailById', empIdObj)
            .then(response => {

                if (response.data.success) {

                    var salaryObj = response.data.result;
                    // alert('success ' + salaryObj[0].DESIGNATION);
                    editSalaryId = salaryObj[0].ID_SALARY_DETAIL;
                    editEmpId = salaryObj[0].ID_EMPLOYEE_PROFILE;
                    editAppoimentData = salaryObj[0].APPOIMENT_DATE;
                    editProbationPeriod = salaryObj[0].PROBATION_PERIOD;
                    editDepartment = salaryObj[0].DEPERTMENT;
                    editGreade = salaryObj[0].GREADE;
                    editEmployeement = salaryObj[0].EMPLOYEMENT;
                    editPermentShift = salaryObj[0].PERMENT_SHIFT;
                    editBasicSalary = salaryObj[0].BASIC_SALARY;
                    editPaymentMethod = salaryObj[0].PAYMENT_METHOD;
                    editTimeCategory = salaryObj[0].TIME_CATEGORY;
                    editEmployeeStatus = salaryObj[0].EMPLOYE_STATUS;

                } else {
                    alert('invalied');
                }
            });

    }

    // load employee department types
    loadDepartmentTypes() {
        var loadDepartmentTypes = [];

        axios.get(window.systemServer + '/system/loadDepartment')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadDepartmentTypes.push({
                            value: response.data.result[i].department_name
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadDepartmentTypes.push({
                            value: response.data[i].department_name
                        });
                    }
                this.setState({ loadDepartmentTypes: loadDepartmentTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load designation types methos 
    loadDesignationTypes() {
        var loadDesignationTypes = [];

        axios.get(window.hrmServer + '/getDesignation')
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < designationObj.length; i++) {

                        loadDesignationTypes.push({
                            value: designationObj[i].DESIGNATION
                        });
                    }
                }
                this.setState({ loadDesignationTypes: loadDesignationTypes });

            }).catch(function (error) {
                // alert(error);
                console.log("designation err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load employeement types 
    loadEmployementTypes() {
        var loadEmployementTypes = [];

        axios.get(window.systemServer + '/system/loadContarctType')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadEmployementTypes.push({
                            value: response.data.result[i].contarct_type
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadEmployementTypes.push({
                            value: response.data[i].contarct_type
                        });
                    }
                this.setState({ loadEmployementTypes: loadEmployementTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load payment methos 
    loadPaymentTypes() {
        var loadPaymentTypes = [];

        axios.get(window.systemServer + '/system/loadPaymentType')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadPaymentTypes.push({
                            value: response.data.result[i].payment_type
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadPaymentTypes.push({
                            value: response.data[i].payment_type
                        });
                    }
                this.setState({ loadPaymentTypes: loadPaymentTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load paymet types methos 
    loadTimeCategoryTypes() {
        var loadTimeCategoryTypes = [];

        axios.get(window.systemServer + '/system/loadDurationType')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadTimeCategoryTypes.push({
                            value: response.data.result[i].duration_type
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadTimeCategoryTypes.push({
                            value: response.data[i].duration_type
                        });
                    }
                this.setState({ loadTimeCategoryTypes: loadTimeCategoryTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    // Image Upload function
    handleUploadImageEdit() {

        const data1 = new FormData();
        data1.append('file', this.uploadInput.files[0]);
        data1.append('filename', this.fileName.value);

        fetch(window.imageUploadServer + '/upload', {
            method: 'POST',
            body: data1,
        }).then((response) => {

            response.json().then((body) => {
                this.setState({ imageURL: window.imageUploadServer + `/${body.file}` });
            });
        });
    }

    // gender value adding
    onGenderEditChanged = gen => (event, expanded) => {
        this.setState({
            gender: event.currentTarget.value
        });
    };

    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseSalary = () => {
        this.setState({ salary: false });
    };

    // search employee personal details
    searchEmployeePersanolDetails() {
        var searchval = $("#empPersanol").val();

        var searchObj = {
            searchval: searchval
        }

        axios.post(window.hrmServer + '/searchEmployeePersnolDatail', searchObj)
            .then(response => {

                if (response.data.success) {

                    var employeeObj = response.data.resultSearch;
                    console.log(employeeObj.length);

                    var data = [];

                    for (var i = 0; i < employeeObj.length; i++) {

                        var genderType = employeeObj[i].ID_GENDER_TYPE;
                        var genderName = "";
                        if (1 == genderType) {
                            genderName = "Male";

                        } else if (2 == genderType) {
                            genderName = "Female";
                        } else {
                            genderName = "Other";
                        }

                        data.push({
                            empId: employeeObj[i].ID_EMPLOYEE_PROFILE,
                            imgURL: employeeObj[i].PROFILE_IMAGE,
                            empCode: "EMP" + employeeObj[i].ID_EMPLOYEE_REGISTRY,
                            nic: employeeObj[i].NIC,
                            epf: employeeObj[i].EPF_CPF,
                            refNo: employeeObj[i].REF_NO,
                            firstName: employeeObj[i].FIRST_NAME,
                            lastName: employeeObj[i].LAST_NAME,
                            middleName: employeeObj[i].MIDDLE_NAME,
                            gender: genderName
                        });

                    }
                }
            });
    }

    // load all emlployee personal data 
    loadData() {
        this.setState({ loading: true });
        axios.get(window.hrmServer + '/getEmployeeDetails')
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var employeeObj = response.data.result;

                    this.appendToTable(employeeObj);

                }
            });

        this.handleCloseEdit();
    }


    // append data into table
    appendToTable(employeeObj) {
        var data = [];
        // console.log("peeen " + employeeObj[31].PROFILE_IMAGE);

        for (var i = 0; i < employeeObj.length; i++) {

            var genderType = employeeObj[i].ID_GENDER_TYPE;
            var genderName = "";
            if (1 == genderType) {
                genderName = "Male";

            } else if (2 == genderType) {
                genderName = "Female";
            } else {
                genderName = "Other";
            }

            data.push({
                empId: employeeObj[i].ID_EMPLOYEE_PROFILE,
                imgURL: employeeObj[i].PROFILE_IMAGE,
                empCode: "EMP" + employeeObj[i].ID_EMPLOYEE_REGISTRY,
                nic: employeeObj[i].NIC,
                epf: employeeObj[i].EPF_CPF,
                refNo: employeeObj[i].REF_NO,
                firstName: employeeObj[i].FIRST_NAME,
                lastName: employeeObj[i].LAST_NAME,
                middleName: employeeObj[i].MIDDLE_NAME,
                gender: genderName,
                greade: employeeObj[i].GREADE,
                empStatus: employeeObj[i].EMPLOYE_STATUS
            });

        }
        this.setState({ loading: false });
        this.setState({ data: data });
    }

    // edit persanol details function
    editEmployeePersonalDetail(model) {

        var editEmpPresnolDetail = {
            editimageURL: this.state.imageURL,
            editEmpId: model.editEmpId,
            editEmpCode: model.editEmpCode,
            editRefNo: model.editRefNo,
            editEPF: model.editEPF,
            editNic: model.editNic,
            editFirstName: model.editFirstName,
            editLastName: model.editLastName,
            editMiddleName: model.editMiddleName,
            editGender: this.state.gender

        }

        // neeed to create edit employee persnol data servise
        axios.post(window.hrmServer + '/editEmployeePersnolDatail', editEmpPresnolDetail)
            .then(res => {

                // alert(res.data.success);
                if (res.data.success) {

                    this.props.alert.success("Employee Updated Successfully");

                    this.handleCloseEdit();
                    this.loadData();
                } else {
                    this.props.alert.error("Unable to Update Please Check !");
                }
            })
    }
    // Add Statement

    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    // edit employee personal details
    onEdit = (model) => {

        this.editEmployeePersonalDetail(model);
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    handleClickSalary = () => {
        // alert(e.value);
        this.setState({ salary: true });
    };


    // Delete Statement
    handleClickDelete = () => {
        // alert(e.value);
        this.setState({ delete: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    stateDelete = {
        canDelete: false
    };

    onDelete = (model) => {
        this.deleteEmployeeDetail(model);
    };

    // Delete Statement
    handleClickActive = () => {
        // alert(e.value);
        this.setState({ active: true });
    };

    handleCloseActive = () => {
        this.setState({ active: false });
    };

    // make employee active
    onActive = (model) => {
        this.activeEmployee(model);
    }

    // delete emplpoyee personal details
    deleteEmployeeDetail(model) {

        var employeeId = model.deleteEmpId;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {
            // alert("Cannot Delete this Employee");
            this.props.alert.error("Cannot Delete This Employee !");
        } else {

            var deleteObj = {
                employeeId: employeeId
            }

            axios.post(window.hrmServer + '/deleteEmployee', deleteObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Employee Inactivated Successfully");
                        this.handleCloseDelete();
                        this.loadData();
                    } else {
                        this.props.alert.error("Unable to Inactivated Please Check !");
                    }
                }).catch(function (error) {
                    alert("Error");
                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error");
                });
        }
    }

    // make active employee
    activeEmployee(model) {
        var employeeId = model.deleteEmpId;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {
            // alert("Cannot Delete this Employee");
            this.props.alert.error("Cannot Active This Employee !");
        } else {

            var deleteObj = {
                employeeId: employeeId
            }

            axios.post(window.hrmServer + '/activeEmployee', deleteObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Employee Actived Successfully");
                        this.handleCloseActive();
                        this.loadData();
                    } else {
                        this.props.alert.error("Unable to Actived Please Check !");
                    }
                }).catch(function (error) {
                    alert("Error");
                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error");
                });
        }
    }


    render() {
        const { classes, openEditContactDialog } = this.props;
        const { canSubmit } = this.state;
        const { canEdit } = this.stateEdit;
        const { canDelete } = this.stateDelete;
        const { value } = this.state;

        return (

            <div className="w-full">
                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    data={this.state.data}
                    columns={[
                        {
                            Header: "Imag Path",
                            accessor: "imgURL",
                            show: false
                        },
                        {
                            Header: "Emp Id",
                            accessor: "empId",
                            show: false
                        },

                        {
                            Header: "Emp ID",
                            accessor: "empCode",
                            // show: false,
                            filterable: true
                        },
                        {
                            Header: "First Name",
                            accessor: "firstName",
                            filterable: true,
                            Cell: ({ row, original }) => (
                                <span>
                                    <span style={{

                                        color: original.empStatus == 'active' ? '#57d500' :
                                            original.empStatus = 'inactive' ? '#Ff0000'
                                                : '#ffbf00',
                                        transition: 'all .3s ease'
                                    }}>
                                        &#x25cf;
                                    </span>
                                    {
                                        row.value == '' ? ' '
                                            : row.firstName
                                    }
                                </span>
                            ),

                        },
                        {
                            Header: "Last Name",
                            accessor: "lastName",
                            filterable: true,

                        },
                        {
                            Header: "NIC No",
                            accessor: "nic",
                            filterable: true

                        },
                        {
                            Header: "EPF No",
                            accessor: "epf",
                            filterable: true

                        },
                        {
                            Header: "Ref No",
                            accessor: "refNo",
                            filterable: true

                        },


                        {
                            Header: "Middle Name",
                            accessor: "middleName",
                            filterable: true,

                        },
                        {
                            Header: "Gender",
                            accessor: "gender",
                            filterable: true,
                        },

                        {
                            Header: "empStatus",
                            accessor: "empStatus",
                            show: false,
                            filterable: true,
                        },

                        {

                            Header: "Action",
                            // accessor: "su",
                            width: 128,

                            Cell: row => (

                                row.original.empStatus == 'active' ?

                                    (<div className="flex items-center w-8 h-8">

                                        <Tooltip
                                            enterDelay={300}
                                            id="tooltip-controlled"
                                            leaveDelay={300}
                                            onClose={this.handleTooltipClose}
                                            onOpen={this.handleTooltipOpen}
                                            open={this.state.open}
                                            placement="bottom"
                                            title="Do you want to inactive ?"
                                        >
                                            <IconButton
                                                onClick={(e) => {
                                                    if (row) {

                                                        deleteEmpId = row.original.empId;
                                                        deleteFirstName = row.original.firstName;
                                                        deleteLastName = row.original.lastName;
                                                        this.setState({ delete: true });
                                                    }
                                                }}
                                            >

                                                <Icon className='text-green'>check_circle</Icon>
                                            </IconButton>
                                        </Tooltip>

                                        <Dialog
                                            open={this.state.delete}
                                            onClose={this.handleClose}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <DialogTitle id="form-dialog-title">Inactive Employee</DialogTitle>
                                            <DialogContent>

                                                <div>

                                                    <Formsy
                                                        onValidSubmit={this.onDelete}
                                                        onValid={this.enableButtonDelete}
                                                        onInvalid={this.disableButtonDelete}
                                                        ref={(form) => this.form = form}
                                                        className="flex flex-col justify-center"
                                                    >
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="deleteEmpId"
                                                            value={deleteEmpId}
                                                        />

                                                        <div className="w-full">
                                                            Are you sure inactive <h4>{deleteFirstName + " " + deleteLastName + " ?"}</h4>
                                                        </div>

                                                        <DialogActions>
                                                            <Button onClick={this.handleCloseDelete} color="primary">
                                                                Cancel
                                                            </Button>


                                                            <Button color="primary" autoFocus
                                                                type="submit"
                                                            >
                                                                Inactive
                                                            </Button>

                                                        </DialogActions>
                                                    </Formsy>
                                                </div>
                                            </DialogContent>

                                        </Dialog>

                                        <Tooltip
                                            enterDelay={300}
                                            id="tooltip-controlled"
                                            leaveDelay={300}
                                            onClose={this.handleTooltipClose}
                                            onOpen={this.handleTooltipOpen}
                                            open={this.state.open}
                                            placement="bottom"
                                            title="Edit employee"
                                        >
                                            <IconButton

                                                onClick={(e) => {
                                                    if (row) {
                                                        editImgUrl = row.original.imgURL;
                                                        this.setState({ imageURL: editImgUrl });

                                                        editEmpId = row.original.empId;
                                                        editNic = row.original.nic;
                                                        editEmpCode = row.original.empCode;
                                                        editRefNo = row.original.refNo;
                                                        editEPF = row.original.epf;
                                                        editFirstName = row.original.firstName;
                                                        editLastName = row.original.lastName;
                                                        editMiddleName = row.original.middleName;
                                                        editGender = row.original.gender;
                                                        editGreade = row.original.greade

                                                        if (editGender == "Male") {
                                                            this.setState({ genderMaleChecked: true });
                                                        } else if (editGender == "Female") {
                                                            this.setState({ genderFemaleChecked: true });
                                                        } else {
                                                            this.setState({ genderOtherChecked: true });
                                                        }

                                                        this.setState({ edit: true });
                                                    }
                                                }}

                                            >
                                                <Icon className="text-blue">mode_edit</Icon>
                                            </IconButton>
                                        </Tooltip>
                                        <Dialog

                                            open={this.state.edit}
                                            onClose={this.handleCloseEdit}
                                            aria-labelledby="form-dialog-title"
                                        >

                                            <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                                <Toolbar className="flex w-full ">
                                                    <Typography className="w-full personl-details-head-margin" variant="subheading" color="inherit">
                                                        Edit Personal Details
                                                    </Typography>
                                                    <IconButton className="" color="inherit" onClick={this.handleCloseEdit} aria-label="Close">
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Toolbar>
                                            </AppBar>

                                            <Formsy
                                                onValidSubmit={this.onEdit}
                                                onValid={this.enableButtonEdit}
                                                onInvalid={this.disableButtonEdit}
                                                ref={(form) => this.form = form}
                                                className=""
                                            >
                                                {/* <DialogTitle id="form-dialog-title">Edit Personal Details</DialogTitle> */}

                                                <DialogContent className="flex flex-wrap">


                                                    <div className="w-full md:w-1/6 relative">

                                                        <div className="MuiAvatar-root-915 w-96 h-96 absolute w-full">
                                                            <img id="profileImg" src={this.state.imageURL} className="w-96 h-96" />
                                                        </div>

                                                        <input accept="image/*" ref={(ref) => { this.uploadInput = ref; }} onChange={this.handleUploadImageEdit} className="{classes.input} invisible" id="icon-button-file" type="file" />
                                                        <label htmlFor="icon-button-file">
                                                            <IconButton color="primary" className="{classes.button} mt-64" component="span">
                                                                <PhotoCamera />
                                                            </IconButton>
                                                        </label>

                                                        <div>
                                                            <input ref={(ref) => { this.fileName = ref; }} value={Date.now()} type="hidden" />
                                                        </div>

                                                    </div>


                                                    <div className="w-full">

                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="editEmpId"
                                                            value={editEmpId}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/3 pr-8"
                                                            type="text"
                                                            name="editEmpCode"
                                                            label="Employee ID"
                                                            value={editEmpCode}
                                                            required
                                                            disabled={true}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/3 pr-8"
                                                            type="text"
                                                            name="editRefNo"
                                                            label="Ref No"
                                                            value={editRefNo}
                                                        // disabled={true}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/3"
                                                            type="text"
                                                            name="editEPF"
                                                            label="EPF No"
                                                            value={editEPF}
                                                            required
                                                        // disabled={true}
                                                        />

                                                    </div>

                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="editNic"
                                                            label="NIC No"
                                                            value={editNic}
                                                            required
                                                        // disabled={true}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="editFirstName"
                                                            label="First Name"
                                                            value={editFirstName}
                                                            required
                                                        // disabled={true}
                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="editLastName"
                                                            label="Last Name"
                                                            value={editLastName}
                                                            required
                                                        // disabled={true}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="editMiddleName"
                                                            label="Middle Name"
                                                            value={editMiddleName}
                                                        // disabled={true}
                                                        />
                                                    </div>

                                                    <div className="w-full mt-16">

                                                        <label className="md:w-1/3 text-lg"><input checked={this.state.genderMaleChecked} onChange={this.onGenderEditChanged('Gen')} className="w-16 h-16" type="radio" name="gender" value="1" />Male</label>
                                                        <label className="md:w-1/3 ml-24 text-lg"><input checked={this.state.genderFemaleChecked} onChange={this.onGenderEditChanged('Gen')} className="w-16 h-16" type="radio" name="gender" value="2" />Female</label>
                                                        <label className="md:w-1/3 ml-24 text-lg"><input checked={this.state.genderOtherChecked} onChange={this.onGenderEditChanged('Gen')} className="w-16 h-16" type="radio" name="gender" value="3" />Other</label>

                                                        <SelectFormsy
                                                            className=" md:w-1/3 ml-40"
                                                            name="editGreade"
                                                            label="Greade"
                                                            value="none"
                                                        >
                                                            <MenuItem className="popup-value-size" value="none">
                                                                <em>None</em>
                                                                {/* Title */}
                                                            </MenuItem>
                                                            <MenuItem className="popup-value-size" value="1">1</MenuItem>
                                                            <MenuItem className="popup-value-size" value="2">2</MenuItem>
                                                            <MenuItem className="popup-value-size" value="3">3</MenuItem>
                                                            <MenuItem className="popup-value-size" value="4">4</MenuItem>
                                                            <MenuItem className="popup-value-size" value="5">5</MenuItem>
                                                        </SelectFormsy>
                                                    </div>

                                                </DialogContent>
                                                <DialogActions>
                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button}  md:h-24">
                                                        Close
                                                    </Button>

                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} md:h-24 ">
                                                        Update
                                                    </Button>
                                                </DialogActions>
                                            </Formsy>
                                        </Dialog>

                                    </div>)

                                    :

                                    (<div className="flex items-center w-8 h-8">

                                        <Tooltip
                                            enterDelay={300}
                                            id="tooltip-controlled"
                                            leaveDelay={300}
                                            onClose={this.handleTooltipClose}
                                            onOpen={this.handleTooltipOpen}
                                            open={this.state.open}
                                            placement="bottom"
                                            title="Do you want to active ?"
                                        >

                                            <IconButton
                                                onClick={(e) => {
                                                    if (row) {

                                                        deleteEmpId = row.original.empId;
                                                        deleteFirstName = row.original.firstName;
                                                        deleteLastName = row.original.lastName;
                                                        this.setState({ active: true });
                                                    }
                                                }}
                                            >

                                                <Icon className='text-red'>cancel</Icon>
                                            </IconButton>
                                        </Tooltip>

                                        <Dialog
                                            open={this.state.active}
                                            onClose={this.handleClose}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <DialogTitle id="form-dialog-title">Active Employee</DialogTitle>
                                            <DialogContent>

                                                <div>

                                                    <Formsy
                                                        onValidSubmit={this.onActive}
                                                        onValid={this.enableButtonDelete}
                                                        onInvalid={this.disableButtonDelete}
                                                        ref={(form) => this.form = form}
                                                        className="flex flex-col justify-center"
                                                    >
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="deleteEmpId"
                                                            value={deleteEmpId}
                                                        />

                                                        <div className="w-full">
                                                            Are you sure active <h4>{deleteFirstName + " " + deleteLastName + " ?"}</h4>
                                                        </div>

                                                        <DialogActions>
                                                            <Button onClick={this.handleCloseActive} color="primary">
                                                                Cancel
                                                            </Button>
                                                            <Button color="primary" autoFocus
                                                                type="submit"
                                                            >
                                                                Active
                                                            </Button>
                                                        </DialogActions>
                                                    </Formsy>
                                                </div>
                                            </DialogContent>

                                        </Dialog>
                                    </div>)
                            )
                        }

                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />

            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(Tab1LoadEmployeePersonalDetails));



// WEBPACK FOOTER //
// ./src/main/content/hr/viewEmployee/components/Tab1LoadEmployeePersonalDetails.js